exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.required-field > label[data-v-ca8ec59e]::after , label[data-v-ca8ec59e]::after {\n    content: '*';\n    color: red;\n    margin-left: 0.25rem;\n}\n.form-control-feedback[data-v-ca8ec59e] {\n    font-weight: 100;\n    color: red;\n    position: initial;\n    text-align: left;\n    height: auto;\n    width: auto;\n}\n.has-danger[data-v-ca8ec59e] {\n    color: red\n}\n.gradientbt[data-v-ca8ec59e]{\n    background: #0F6940;\n    color: white\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-ca8ec59e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/region/RegionDetail.vue
// module id = 233
// module chunks = 0